<div id="residency">
  <div name="main" class="p-8 flex flex-col sm:w-auto bg-white">
    <div class="md:px-16">
      <div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/4</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Current Employer</h2>
            <p>Please review your current employment information and update as needed.</p>
            <p>By continuing, you approve Tricon contacting your employer for a Verification of Employment.</p>
          </div>
        </div>
      </div>
      <form id="employmentForm" #employmentForm="ngForm" class="flex flex-col pt-8">
        <div *ngFor="let employment of employments; let i = index; trackBy:listTrack; last as isLast">
          <div>
            <div *ngIf="isLast">
              <div *ngIf="i != 0" class="mt-8">
              </div>
              <label>Current Employer</label>
            </div>
            <div *ngIf="!isLast">
              <label>Previous Employer</label>
            </div>
            <div class="md:flex md:items-center">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Employer Name</mat-label>
                  <input matInput name="EmployerName[{{i}}]" id="EmployerName[{{i}}]" required
                    [(ngModel)]="employment.EmployerName" #EmployerName="ngModel" [disabled]="employment.IsCurrnet">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Industry</mat-label>
                  <mat-select name="RentalIndustryKey[{{i}}]" id="RentalIndustryKey[{{i}}]" required
                    [(ngModel)]="employment.RentalIndustryKey" #Industry="ngModel" [disabled]="employment.IsCurrnet">
                    <mat-option *ngFor="let industry of industries" [value]="industry.value">
                      {{industry.label}}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="md:flex">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Occupation</mat-label>
                  <input matInput name="Occupation[{{i}}]" id="Occupation[{{i}}]" required
                    [(ngModel)]="employment.Occupation" #Occupation="ngModel">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Phone</mat-label>
                  <mat-input-tel name="Phone[{{i}}]" id="Phone[{{i}}]" required [(ngModel)]="employment.PhoneNumber"
                    #Phone="ngModel" [disabled]="employment.IsCurrnet"></mat-input-tel>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="md:flex">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Start Date</mat-label>
                  <input matInput [matDatepicker]="startDatePicker" name="startDate[{{i}}]" id="startDate[{{i}}]"
                    required [(ngModel)]="employment.StartDate" #StartDate="ngModel" [disabled]="employment.IsCurrnet">
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                  <mat-error>Please fill out this field MM/DD/YYYY</mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="endDatePicker" name="endDate[{{i}}]" id="endDate[{{i}}]" required
                    [(ngModel)]="employment.EndDate" #EndDate="ngModel">
                  <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker></mat-datepicker>
                  <mat-error>Please fill out this field MM/DD/YYYY</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="md:flex ">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Supervisor's Name</mat-label>
                  <input matInput name="SupervisorName[{{i}}]" id="SupervisorName[{{i}}]" required
                    [(ngModel)]="employment.SupervisorName" #SupervisorName="ngModel" [disabled]="employment.IsCurrnet">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Supervisor's Phone</mat-label>
                  <mat-input-tel name="SupervisorPhone[{{i}}]" id="SupervisorPhone[{{i}}]" required
                    [(ngModel)]="employment.SupervisorPhoneNumber" #SupervisorPhone="ngModel"
                    [disabled]="employment.IsCurrnet"></mat-input-tel>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="md:flex">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Address</mat-label>
                  <input matInput name="Address[{{i}}]" id="Address[{{i}}]" required [(ngModel)]="employment.Address"
                    #Address="ngModel" [disabled]="employment.IsCurrnet">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Monthly Gross Income</mat-label>
                  <input matInput name="MonthlyPay[{{i}}]" id="MonthlyPay[{{i}}]" required
                    [(ngModel)]="employment.MonthlyPay" #MonthlyPay="ngModel">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="md:w-1/2 md:pr-2">
              <mat-form-field class="w-full my-2">
                <mat-label>Employment Status</mat-label>
                <mat-select name="EmploymentStatusKey[{{i}}]" id="EmploymentStatusKey[{{i}}]" required
                  [(ngModel)]="employment.EmploymentStatusKey" #EmploymentStatusKey="ngModel">
                  <mat-option *ngFor="let status of employmentStatus" [value]="status.value">
                    {{status.label}}
                  </mat-option>
                </mat-select>
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="i != 0">
              <button mat-button color="accent" (click)="onRemoveEmployerClick(employment)"
                style="color: #545859">Remove Employer</button>
            </div>
          </div>
        </div>
        <div class="md:flex md:justify-between md:items-center ">
          <div>
            <button mat-button color="accent" (click)="onAddEmployerClick()" style="color: #545859">ADD ADDITIONAL
              EMPLOYER</button>
          </div>
          <div class="text-right">
            <button mat-flat-button color="primary" (click)="cancelEdit()" class="h-10 px-6 my-2"
              *ngIf="AddAdditionalApplicantKey != null">CANCEL EDIT</button>
            <button mat-flat-button color="primary" (click)="onSubmit()" class="h-10 px-6 my-2 ml-2">CONTINUE</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>